// apps/web/src/layouts/components/SidebarCommissionAttentionBadge.tsx
//
// Badge de atenção do financeiro (Comissões > Extrato): contestações abertas +
// pendências resolvidas aguardando palavra final do admin. O número vem de
// `useSidebarBadgeCounts()`, montado uma vez no topo da sidebar admin.

import { useTranslation } from 'react-i18next';

import { SidebarCountBadge, type SidebarCountBadgeVariant } from './SidebarCountBadge';

export interface SidebarCommissionAttentionBadgeProps {
  count: number;
  variant?: SidebarCountBadgeVariant;
}

export function SidebarCommissionAttentionBadge({
  count,
  variant,
}: SidebarCommissionAttentionBadgeProps) {
  const { t } = useTranslation('admin');
  return (
    <SidebarCountBadge
      count={count}
      variant={variant}
      testId="sidebar-commission-attention-badge"
      label={t('sidebar.badges.commission_attention', { count })}
    />
  );
}
